import * as React from "react";
import * as moment from "moment";
import {InfoBanner} from "@ferry/portal-core";

interface IProps {
    interaction: any;
}

export class MigratedRenewalBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const vehicle: any = this.props.interaction?.vehicles[0];
        const pendingRenewalDate: moment.Moment = moment.utc(this.props.interaction?.headerInfo.startDate, moment.ISO_8601);

        return (
            <InfoBanner wording={
                <>
                    <strong>Rest easy</strong> - your car insurance policy for car {vehicle?.make} {vehicle?.model} {vehicle?.registrationNumber} is scheduled to renew on {pendingRenewalDate.format("D MMMM YYYY, 00:00")}.{' '}<br/>
                    No payment will be taken until then.
                </>
            }/>
        )
    }
}
